<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-40">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
          <companySide
            class="mt-20"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <div class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
            <div class="info_form mt-20">
              <el-form
                ref="form"
                :rules="rules"
                :label-position="labelPosition"
                :model="form"
                label-width="120px"
              >
                <el-form-item label="企业名称 :" prop="name" style="width: 60%">
                  <el-input v-model="form.name" max="50" clearable></el-input>
                </el-form-item>
                <el-form-item label="企业法人 :" prop="legalPerson" style="width: 60%">
                  <el-input v-model="form.legalPerson" clearable></el-input>
                </el-form-item>
                <el-form-item
                  class="business"
                  label="营业执照:"
                  prop="businessLicense"
                  style="width: 60%"
                >
                  <el-input v-model="form.businessLicense" disabled  clearable></el-input>
                  <el-upload
                    class="upload-demo"
                    action="/api/zwb/app/oss/public/upload"
                    :headers="{ token: token }"
                    :on-success="onSuccess"
                    :show-file-list="false"
                    :before-upload="handlePictureCardPreview"
                    :file-list="fileList"
                    :limit="2"
                    list-type="picture"
                  >
                    <button class="busin_btn" size="small" @click.prevent="">
                      上传企业营业执照
                    </button>
                  </el-upload>
                </el-form-item>
                <el-form-item
                  class="code"
                  label="验证码："
                  prop="imgCode"
                  style="width: 60%"
                >
                  <el-input
                    type="text"
                    v-model="form.imgCode"
                    auto-complete="off"
                    maxlength="5"
                  ></el-input>
                  <img
                    class="graphic_code"
                    :src="imgUrl"
                    alt=""
                    @click.prevent="getCaptcha()"
                  />
                </el-form-item>
                <!-- <el-form-item
                                    label="发送手机号码："
                                    style="width: 80%"
                                  >
                                    <p class="phone_tel">{{telPhone}}</p>
                                  </el-form-item> -->
                <!-- <el-form-item  class="shrot" label="验证短信 ：" prop="smsCode" style="width: 60%;">
                                    <el-input v-model="form.smsCode" maxlength="6" clearable></el-input>
                                    <button  class="short_btn" @click.prevent="onCode()">{{getCodeText}}</button>
                                </el-form-item> -->
                <el-form-item prop="agree" class="fuck">
                  <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                  <div style="margin-left: 5px">
                    我已阅读并同意《
                    <span class="agree" @click="settChange()">平台会员协议</span>
                    》
                  </div>
                </el-form-item>
                <div class="tel mt-30">
                  <el-button class="refer" @click="submitForm('form')"
                    >提交认证信息</el-button
                  >
                </div>
              </el-form>
            </div>
          </div>
        </el-main>
      </el-container>

      <!--平台会员协议弹框-->
      <div class="sett_dialog" v-show="dialogTableVisible">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">平台会员协议</p>
            <p class="sett_jitr">
              <span v-if="!isImg">{{ time }}s</span>
              <img
                v-show="isImg"
                src="../../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <div class="sett_desc" v-html="membershipAgreement.des"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendSmsCaptcha, userphone } from "@/api/my";
import { certifiInfo } from "@/api/company";
import { changtype,agreement } from "@/api/coment";
import { getToken } from "@/utils/auth";
import { getUUID } from "@/utils/index";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
export default {
  components: {
    sidebar,
    companySide,
    commBanner,
    titleHead,
    contTitle,
  },
  data() {
    return {
      membershipAgreement: "",
      isImg: false,
      time: 10,
      dialogTableVisible: false,
      headTitle: "企业咨询",
      contTitle1: "企业基本信息",
      contTitle2: "企业认证",
      obj: {
        title: "企业资讯审核",
        isShow: false,
        isColor: false,
        roleType: 3,
        personalType: 9,
      },
      labelPosition: "left",
      fileList: [],
      form: {
        name: "", //公司名称
        legalPerson: "", //企业法人
        businessLicense: "", //营业执照
        smsCode: "", //验证短信,
        imgCode: "",
        agree: "",
      },
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        legalPerson: [{ required: true, message: "请输入企业法人", trigger: "blur" }],
        businessLicense: [
          { required: true, message: "请上传营业执照", trigger: "change" },
        ],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入验证短信", trigger: "blur" }],
        agree: [
          {
            required: true,
            message: "请接受智污邦平台会员协议",
            trigger: "change",
          },
        ],
      },
      getCodeText: "获取验证码",
      token: getToken(),
      isButton: false,
      imgUrl: "",
      userinfo: {},
      isTery: true,
      telPhone: "",
    };
  },
  created() {
    this.userinfo = this.$store.state.user.userInfo.data;
    this.getCaptcha();
    this.getPhone();
    // this.getAgreement();
  },
  mounted() {
    this.formInit();
  },
  methods: {
    //文件上传成功后，返回
    onSuccess(res) {
      if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
        this.form.businessLicense = res.url;
      }
    },
    //文件上传前，调用
    handlePictureCardPreview(file) {
      //上传前对图片类型和大小进行判断
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //获取手机号
    getPhone() {
      let parmas = {};
      userphone(parmas)
        .then((res) => {
          if (res.code == 0) {
            this.telPhone = res.data;
          }
        })
        .catch((err) => {});
    },
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //倒计时
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    //发送验证码
    // onCode(){
    // if(!this.form.imgCode){
    //     this.$message({
    //     message: "请输入图形验证码",
    //     type: "warning",
    //     duration: 1000,
    //     })
    //     return;
    //   }
    //     let params = {
    //     uuid:this.uid,
    //     imgCode: this.form.imgCode,
    // };
    // this.setTimer();
    // sendSmsCaptcha(params).then(res =>{
    //     if (res.code == 0) {
    //         this.$message({
    //         message: "验证码发送成功",
    //         type: "success",
    //         duration: 1000,
    //         });
    //     }
    // }).catch(err=>{})
    // },

    getAgreement() {
      agreement()
        .then((res) => {
          this.membershipAgreement = res.page.filter(
            (item) => item.name == "平台会员协议"
          )[0];
        })
        .catch((err) => {});
    },
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
    },

    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          certifiInfo(this.form)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "等待审核！",
                  type: "success",
                  duration: 3000,
                });
                this.getChangtype(3);
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    //发布需求
    gorelease() {
      this.$router.push("/demand");
    },
    formInit() {
      if (!this.userinfo) {
        this.$store.dispatch("user/getInfo");
        return;
      }
      delete this.userinfo.id;
      switch (this.userinfo.status) {
        case 1:
          this.form = this.userinfo;
          this.isTery = false;
          break;
      }
    },
    //升级用户类型
    getChangtype(data) {
      let params = { type: data };
      changtype(params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data == null) {
              //  this.$message({
              //    message:'审核未通过,请重新提交认证!',
              //    type:'info',
              //    duration:3000
              //  })
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
/* .el-aside{
    height:930px;
} */
.mt-20 {
  margin-top: 20px;
}
.mb-40 {
  margin-bottom: 40px;
}
.el-form-item {
  text-align: left;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
/deep/.business {
  position: relative;
}
/deep/ .upload-demo {
  position: absolute;
  top: 0;
  right: 0;
}
.busin_btn {
  width: 151px;
  height: 50px;
  background: #e5e5e5;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  border: none;
}
/deep/.shrot {
  position: relative;
}
/deep/.short_btn {
  position: absolute;
  width: 125px;
  height: 50px;
  top: 0;
  right: 0;
  background: #e5e5e5;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border: none;
  color: #999999;
}
.refer {
  width: 121px;
  height: 38px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border: none;
}

.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}

/**协议弹框 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
/**协议弹框 */
.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_attestation.vue